export default __webpack_public_path__ + "static/media/regulations2.67426a1c.svg";